module.exports = __webpack_public_path__ + "img/zhifubao.330ab5aa.png";